module.exports = __webpack_public_path__ + "img/Intersection 4@2x.21fe7628.png";